import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formId", "portalId", "env", "region", "editorVersion", "resolveEditorVersion", "loadingFallback"],
  _excluded2 = ["onFormReady"];
import { useCallback, useRef, useState } from 'react';
import styled from 'foundations-theming-specialty/utils';
import { useResolveEditorVersion } from './useResolveEditorVersion';
import { useFormEventDispatch } from './useFormEventDispatch';
import { VersionOneForm } from './VersionOneForm';
import { VersionTwoForm } from './VersionTwoForm';
import { FormLoadingPlaceholder } from './FormLoadingPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "HubSpotForm__Wrapper"
})(["transition:opacity 0.2s ease-in-out;opacity:", ";"], ({
  $visible
}) => $visible ? 1 : 0);
export function HubSpotForm(_ref) {
  let {
      formId,
      portalId,
      env,
      region,
      editorVersion: editorVersionProp,
      resolveEditorVersion,
      loadingFallback
    } = _ref,
    eventCallbacks = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isReady, setIsReady] = useState(false);
  const resolvedVersion = useResolveEditorVersion({
    formId,
    portalId,
    env,
    editorVersion: editorVersionProp,
    resolveEditorVersion
  });
  const prevFormKeyRef = useRef(`${portalId}:${formId}:${env}`);
  const formKey = `${portalId}:${formId}:${env}`;
  if (prevFormKeyRef.current !== formKey) {
    prevFormKeyRef.current = formKey;
    setIsReady(false);
  }
  const {
      onFormReady
    } = eventCallbacks,
    restEventCallbacks = _objectWithoutPropertiesLoose(eventCallbacks, _excluded2);
  const handleFormReady = useCallback(() => {
    setIsReady(true);
    onFormReady === null || onFormReady === void 0 || onFormReady();
  }, [onFormReady]);
  const dispatch = useFormEventDispatch(Object.assign({}, restEventCallbacks, {
    onFormReady: handleFormReady
  }));
  const fallback = loadingFallback === undefined ? /*#__PURE__*/_jsx(FormLoadingPlaceholder, {}) : loadingFallback;
  if (resolvedVersion == null) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: fallback
    });
  }
  const FormComponent = resolvedVersion === 2 ? VersionTwoForm : VersionOneForm;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isReady && fallback, /*#__PURE__*/_jsx(Wrapper, {
      $visible: isReady,
      children: /*#__PURE__*/_jsx(FormComponent, {
        formId: formId,
        portalId: portalId,
        env: env,
        region: region,
        dispatch: dispatch
      })
    })]
  });
}